export const PET_TYPE_OPTIONS = [
  { value: 'cachorro', label: 'Cachorro' },
  { value: 'gato', label: 'Gato' },
  { value: 'ave', label: 'Ave' },
  { value: 'peixe', label: 'Peixe' },
  { value: 'outro', label: 'Outro' },
];

export const PET_TYPE_TRANSLATIONS: Record<string, string> = {
  cachorro: 'Cachorro',
  gato: 'Gato',
  ave: 'Ave',
  peixe: 'Peixe',
  outro: 'Outro',
};

export const initialValues = {
  nome: '',
  tipo: '',
  raca: '',
  idade: 0,
  peso: 0,
  cor: '',
  observacoes: '',
  foto: undefined,
  tenant_id: '',
}; 